import React from 'react';
import type CustomDevMenuElement from './types';

const CustomDevMenu: CustomDevMenuElement = Object.assign(() => <></>, {displayName: 'CustomDevMenu'});

export default CustomDevMenu;
